module.exports = __webpack_public_path__ + "static/media/SoccerLogo.f4f9e045.png";